module.exports = __webpack_public_path__ + "static/media/slider02.84f9654a.jpg";